/**
 * FUNCIONALIDADES POR TIPO DE NEGOCIO (FUNCIONES-POR-TIPO-T1, Josse 3-nov, Ares #42309).
 *
 * AUDIENCIA: Josse o un admin de Nexo, en el panel, en escritorio o celular. Responde: que trae encendido cada tipo de
 * negocio (restaurante, tienda, almacen, joyeria...) y que defectos son todavia una propuesta.
 *
 * Poco texto: un tipo a la vez, sus funcionalidades por grupo con "encendida" o "apagada", y "propuesta" en las que Josse
 * no ha confirmado. El panel no decide nada: lee la matriz de la base (nexo-api PR 768). Nace de la plantilla de vista
 * (contrato de vista): regreso, tema por variables, insignia y los tres estados. El ajuste por negocio viene despues.
 *
 * @module presentation/views/FuncionalidadesView
 */
import { FuncionalidadesApiClient } from '../../infrastructure/api/FuncionalidadesApiClient.js';
import { leerMatriz, resumenDelTipo, fraseDeLaFalla } from '../../application/negocios/funcionalidadesPorTipo.js';
import { esc } from '../shared/texto.js';
import { insigniaHtml, COLOR_ESTADO } from '../shared/insignia.js';
import { regresoHtml } from '../shared/regreso.js';

const ESTILO = {
  caja: 'background:var(--bg-card);border:1px solid var(--border-default);border-radius:var(--radius-md);padding:12px 16px;margin-top:12px',
  suave: 'color:var(--text-secondary);font-size:0.875rem',
  titulo: 'color:var(--text-heading);font-size:0.875rem;font-weight:600;margin:0 0 6px',
  fila: 'display:flex;justify-content:space-between;align-items:center;gap:12px;padding:8px 0;border-top:1px solid var(--border-muted);color:var(--text-primary)',
  tipo: 'padding:6px 12px;border-radius:var(--radius-lg);border:1px solid var(--border-default);background:transparent;color:var(--text-primary);cursor:pointer;font-size:0.875rem',
  tipoActivo: 'background:var(--bg-tertiary);border-color:var(--accent-blue);color:var(--text-strong)'
};

/** Lo pintado, puro sobre la matriz leida (para el guardia). */
export function funcionalidadesHtml(matriz, tipoElegido) {
  if (!matriz.tipos.length) return `<p style="${ESTILO.suave}">Todavia no hay tipos de negocio con funcionalidades en el catalogo.</p>`;
  const tipo = matriz.grupos[tipoElegido] ? tipoElegido : matriz.tipos[0].tipo;
  const r = resumenDelTipo(matriz.grupos[tipo]);
  const tipos = `<div role="tablist" style="display:flex;flex-wrap:wrap;gap:6px">${matriz.tipos.map((t) => `<button type="button" role="tab" data-func-tipo="${esc(t.tipo)}" aria-selected="${t.tipo === tipo}" style="${ESTILO.tipo}${t.tipo === tipo ? ';' + ESTILO.tipoActivo : ''}">${esc(t.visible)}</button>`).join('')}</div>`;
  const resumen = `<p data-func-resumen style="${ESTILO.suave};margin:10px 0 0">${r.encendidas} de ${r.total} encendidas${r.propuestas ? ` · ${r.propuestas} propuesta${r.propuestas === 1 ? '' : 's'} sin confirmar` : ''}</p>`;
  const grupos = matriz.grupos[tipo].map((g) => `<section data-func-grupo="${esc(g.grupo)}" style="${ESTILO.caja}"><h2 style="${ESTILO.titulo}">${esc(g.grupo)}</h2>${g.filas.map((f) => `<div data-func="${esc(f.funcionalidad)}" style="${ESTILO.fila}"><span>${esc(f.nombre)}</span><span style="display:flex;gap:6px;align-items:center">${f.confirmada ? '' : `<span data-func-propuesta style="${ESTILO.suave}">propuesta</span>`}${insigniaHtml(f.activa ? 'encendida' : 'apagada', f.activa ? COLOR_ESTADO.ok : COLOR_ESTADO.apagado)}</span></div>`).join('')}</section>`).join('');
  return tipos + resumen + grupos;
}

export async function renderFuncionalidades(container) {
  if (!container) return;
  const cabeza = `${regresoHtml()}<h1 style="margin:8px 0 4px">Funcionalidades por tipo de negocio</h1><p style="${ESTILO.suave};margin:0 0 12px">Lo que cada tipo trae encendido al crear el negocio.</p>`;
  container.innerHTML = `${cabeza}<div data-func-cuerpo aria-busy="true"><p style="${ESTILO.suave}">Cargando...</p></div>`;
  const res = await FuncionalidadesApiClient.porTipo();
  const cuerpo = container.querySelector('[data-func-cuerpo]');
  if (!cuerpo) return;
  cuerpo.removeAttribute('aria-busy');
  if (!res.ok) {
    cuerpo.innerHTML = `<p data-func-error style="color:var(--accent-red)">${esc(fraseDeLaFalla(res.motivo))}</p>`;
    return;
  }
  const matriz = leerMatriz(res.data);
  let elegido = matriz.tipos[0]?.tipo;
  const pintar = () => { cuerpo.innerHTML = funcionalidadesHtml(matriz, elegido); };
  pintar();
  cuerpo.addEventListener('click', (e) => {
    const b = e.target.closest('[data-func-tipo]');
    if (!b) return;
    elegido = b.getAttribute('data-func-tipo');
    pintar();
  });
}
